import { useLayoutEffect, useRef, useState } from "react";

/** The element's content size, kept current with a ResizeObserver. */
export function useSize<T extends HTMLElement>(): [React.RefObject<T | null>, { w: number; h: number }] {
	const ref = useRef<T>(null);
	const [size, setSize] = useState({ w: 0, h: 0 });
	useLayoutEffect(() => {
		const el = ref.current;
		if (!el) return;
		const read = () => setSize({ w: el.clientWidth, h: el.clientHeight });
		read();
		const ro = new ResizeObserver(read);
		ro.observe(el);
		return () => ro.disconnect();
	}, []);
	return [ref, size];
}
